export default __webpack_public_path__ + "static/media/log.5d8e6eed.png";